/* global console PowerPoint $ */

import { clearGriddShapes } from "./baking/clearGriddShapes";
import { getCurrentSlideId } from "./pptapi";
import { calculateShapeCoords } from "./baking/calculateShapeCoords";
import { generateDrawingCommands } from "./baking/generateDrawingCommands";
import { draw } from "./baking/drawShapes";

export async function bake(slideId, gridd, styleSheet) {
  console.log("baking start", { slideId, gridd, styleSheet });

  const id = await getCurrentSlideId();
  console.log("to current slide", id);

  if (id.slideId === "SLIDE" && id.presId === "PRES") {
    console.log("Not running in PowerPoint, baking aborted");
    return;
  }

  const griddObjectId = await clearGriddShapes(id);

  let top, left, width, height;
  try {
    await PowerPoint.run(async (context) => {
      const slide = context.presentation.slides.getItem(id.slideId);
      const gridd = slide.shapes.getItem(griddObjectId);
      gridd.load({ top: true, left: true, width: true, height: true });
      await context.sync();
      top = gridd.top;
      left = gridd.left;
      width = gridd.width;
      height = gridd.height;
    });
  } catch (error) {
    console.error("Error during detecting Gridd top-left coordinate, aborting baking.", error);
    return;
  }

  const cellsCoords = calculateShapeCoords(left, top, gridd, parseInt(styleSheet?.cellPadding ?? "8"));

  console.log("Baking - calculations done, generating drawing commands", { cellsCoords });

  // Cache icon and shape svgs
  let iconCache = {};
  let shapeCache = {};
  try {
    $("svg").each(function () {
      const className = $(this).attr("class");
      if (className?.startsWith("shape")) {
        shapeCache[className] = $(this).prop("outerHTML");
      } else iconCache[className] = $(this).prop("outerHTML");

      const id = $(this).attr("id");
      iconCache[id] = $(this).prop("outerHTML");
    });
    console.warn("All SVGs cached", { iconCache, shapeCache });
  } catch (error) {
    console.error("Baking - error during caching icons, aborting baking.", error);
  }

  // Generate drawing data
  const drawingCommands = generateDrawingCommands(
    left,
    top,
    width,
    height,
    gridd,
    cellsCoords,
    iconCache,
    shapeCache,
    styleSheet
  );

  // TODO: collapse drawingCommands into batches of await context.sync() after ordered

  console.log("Baking - preparation done, starting drawing", { drawingCommands });

  await draw(id, drawingCommands, left, top);

  console.log("Baking - drawing finished");

  // TODO: group all Gridd shapes into one

  // After all generate finished, remove Gridd content placeholder
  try {
    await PowerPoint.run(async (context) => {
      const slide = context.presentation.slides.getItem(id.slideId);
      const gridd = slide.shapes.getItem(griddObjectId);
      gridd.delete();
      await context.sync();
    });
  } catch (error) {
    console.error("Failed removing Gridd with error, please remove manually!", error);
    return;
  }

  console.log("baking finished", { id, slideId, gridd, styleSheet });
}
